import React, { useEffect, useState } from "react";
import { Link, NavLink, useLocation } from "react-router-dom";
import { Menu, X } from "lucide-react";

const NAV_ITEMS = [
    { to: "/technologies", label: "Technologies" },
    { to: "/platforms", label: "Platforms" },
    { to: "/applications", label: "Applications" },
    { to: "/case-studies", label: "Case Studies" },
    { to: "/services", label: "Services" },
    { to: "/insights", label: "Insights" },
    { to: "/about", label: "About" },
];

export default function Navbar() {
    const [open, setOpen] = useState(false);
    const [scrolled, setScrolled] = useState(false);
    const loc = useLocation();
    useEffect(() => setOpen(false), [loc.pathname]);
    useEffect(() => {
        const onScroll = () => setScrolled(window.scrollY > 20);
        window.addEventListener("scroll", onScroll);
        return () => window.removeEventListener("scroll", onScroll);
    }, []);
    return (
        <header
            data-testid="site-navbar"
            className={`fixed top-0 inset-x-0 z-50 glass-nav transition-all ${scrolled ? "py-2" : "py-4"}`}
        >
            <div className="max-w-[1440px] mx-auto px-6 md:px-10 flex items-center justify-between">
                <Link to="/" className="flex flex-col leading-none" data-testid="nav-logo">
                    <img
                        src="/brand/lockup-nav.png"
                        alt="Skovomax"
                        className="h-5 sm:h-6 w-auto select-none"
                        draggable="false"
                    />
                    <span className="font-mono-tech text-[8.5px] sm:text-[9px] tracking-[0.26em] uppercase text-white/45 mt-1.5">
                        Sensors · Systems · Intelligence
                    </span>
                </Link>

                <nav className="hidden lg:flex items-center gap-7">
                    {NAV_ITEMS.map((n) => (
                        <NavLink
                            key={n.to}
                            to={n.to}
                            data-testid={`nav-${n.label.toLowerCase().replace(/\s+/g, "-")}`}
                            className={({ isActive }) =>
                                `font-mono-tech text-[11px] tracking-[0.18em] uppercase transition-colors ${
                                    isActive ? "text-[var(--accent-indigo)]" : "text-white/60 hover:text-white"
                                }`
                            }
                        >
                            {n.label}
                        </NavLink>
                    ))}
                </nav>

                <div className="hidden lg:flex items-center gap-3">
                    <Link to="/contact" data-testid="nav-contact-cta" className="btn-primary">
                        Request Demo
                    </Link>
                </div>

                <button
                    className="lg:hidden text-white p-2"
                    onClick={() => setOpen((v) => !v)}
                    data-testid="mobile-menu-toggle"
                    aria-label="Toggle menu"
                >
                    {open ? <X size={22} /> : <Menu size={22} />}
                </button>
            </div>

            {open && (
                <div className="lg:hidden border-t border-white/10 bg-black/90 backdrop-blur-xl">
                    <div className="px-6 py-6 flex flex-col gap-4">
                        {NAV_ITEMS.map((n) => (
                            <NavLink
                                key={n.to}
                                to={n.to}
                                data-testid={`mnav-${n.label.toLowerCase().replace(/\s+/g, "-")}`}
                                className="font-mono-tech text-[12px] tracking-[0.18em] uppercase text-white/80"
                            >
                                {n.label}
                            </NavLink>
                        ))}
                        <Link to="/contact" data-testid="mnav-contact-cta" className="btn-primary w-full mt-2">
                            Request Demo
                        </Link>
                    </div>
                </div>
            )}
        </header>
    );
}
